<template>
    <div>
<Navigation/>
  <!-- Start Team Area -->
      <section class="team-section pt-100 pb-70">
        <div class="container">
          <div class="team-title-area">
            <div class="row align-items-center">
              <div class="col-lg-7">
                <div class="section-title text-left">
                <span>
                  <i class="flaticon-support"></i>
                  Meet Our Leaders
                </span>
                  <h2>CLC Leadership</h2>
                  <p>

                  </p>
                </div>
              </div>

            </div>
          </div>

          <div class="row">






 <div class="col-lg-3 col-md-5 col-sm-5">
              <div class="team-item">
                <div class="image">
                  <img class="team-image" src="assets/img/clc/clc_leader4.png" alt="image" />

                  <ul class="social">
                    <li>
                      <a href="#" target="_blank">
                        <i class="bx bxl-facebook"></i>
                      </a>
                    </li>
                    <li>
                      <a href="#" target="_blank">
                        <i class="bx bxl-twitter"></i>
                      </a>
                    </li>
                    <li>
                      <a href="#" target="_blank">
                        <i class="bx bxl-linkedin"></i>
                      </a>
                    </li>
                    <li>
                      <a href="#" target="_blank">
                        <i class="bx bxl-instagram"></i>
                      </a>
                    </li>
                  </ul>
                </div>

                <div >
                  <h5>Dr. Goodhead</h5>
                  <span>President, CLC </span>
                 

                </div>
              </div>
            </div>




















            <div class="col-lg-3 col-md-5 col-sm-5">
              <div class="team-item">
                <div class="image">
                  <img class="team-image" src="assets/img/clc/clc_leader1.png" alt="image" />

                  <ul class="social">
                    <li>
                      <a href="#" target="_blank">
                        <i class="bx bxl-facebook"></i>
                      </a>
                    </li>
                    <li>
                      <a href="#" target="_blank">
                        <i class="bx bxl-twitter"></i>
                      </a>
                    </li>
                    <li>
                      <a href="#" target="_blank">
                        <i class="bx bxl-linkedin"></i>
                      </a>
                    </li>
                    <li>
                      <a href="#" target="_blank">
                        <i class="bx bxl-instagram"></i>
                      </a>
                    </li>
                  </ul>
                </div>

                <div class="content">
                  <h3>Gaolebale Isaac</h3>
                  <span>Director, CLC </span>
                  <br>
                  <span style="text-align:justify">
                  Pastor Isaac Gaolebale, fondly nicknamed Bishop by Dr. Goodhead, has remained one of the most dedicated member and leader of the RPC, BLI and CLC, the three realms where he holds leadership positions. He is the music director and resident pastor of RPC; the Chairperson of BLI and Director of CLC. 
                  Bishop pioneered Evening snacks; an RPC non-denominational daily devotional. Evening Snack has contributors like, Pastor Olivia, Apostle Paul, Pastor Dennis &amp; Drue
                  Pee Iyke (Bishop) is a dedicated, resourceful and goal-driven professional educator. A mentor, manager and Pastor with a solid commitment to the social, spiritual, academic growth and development of every human being he contacts. 
                  Educationally, Bishop holds Bachelor of Education (Sci) in Pure and Applied Mathematics and a Master of Science in Financial Management, Amity University India. Bishop is married to Madam Isaac and the two are blessed with three lovely kids.</span>

                </div>
              </div>
            </div>

           <div class="col-lg-3 col-md-5 col-sm-5">
              <div class="team-item">
                <div class="image">
                  <img class="team-image" src="assets/img/clc/clc_leader2.png" alt="image" />

                  <ul class="social">
                    <li>
                      <a href="#" target="_blank">
                        <i class="bx bxl-facebook"></i>
                      </a>
                    </li>
                    <li>
                      <a href="#" target="_blank">
                        <i class="bx bxl-twitter"></i>
                      </a>
                    </li>
                    <li>
                      <a href="#" target="_blank">
                        <i class="bx bxl-linkedin"></i>
                      </a>
                    </li>
                    <li>
                      <a href="#" target="_blank">
                        <i class="bx bxl-instagram"></i>
                      </a>
                    </li>
                  </ul>
                </div>

                <div class="content">
                  <h3>Thokozile Nyirenda</h3>
                  <span> Legal Director, CLC groups </span>
                  <br>
                  <span>
                    Thokozile Nyirenda is a born-again child of God who loves the Lord with all of her heart. The devil had given her his best but Pastor Tee Kay found them nothing to compare with the love of Jesus. So, Tee Kay is literally a Jesus addict. Bar Tokozile was admitted attorney at law practicing in Botswana in 2019. Now and always Tee remains a member and legal adviser of CLC groups (RPC, IPDYI, THC &amp; BLI). Barrister has vast experience in litigation, legal research and legal documents drafting. She drafted the CLC Constitution amongst other CLC documents. Her field of practice is in civil law, criminal law, labour law, property law and company law.
                  </span>
                </div>
              </div>
            </div>
           <div class="col-lg-3 col-md-5 col-sm-5">
              <div class="team-item">
                <div class="image">
                  <img class="team-image" src="assets/img/clc/clc_leader3.png" alt="image" />

                  <ul class="social">
                    <li>
                      <a href="#" target="_blank">
                        <i class="bx bxl-facebook"></i>
                      </a>
                    </li>
                    <li>
                      <a href="#" target="_blank">
                        <i class="bx bxl-twitter"></i>
                      </a>
                    </li>
                    <li>
                      <a href="#" target="_blank">
                        <i class="bx bxl-linkedin"></i>
                      </a>
                    </li>
                    <li>
                      <a href="#" target="_blank">
                        <i class="bx bxl-instagram"></i>
                      </a>
                    </li>
                  </ul>
                </div>

                <div class="content">
                  <h3>Clattah Mhaka</h3>
                  <span>Finance Director, CLC groups</span>
                  <br>
                  <span>
                  Clattah joined Rhema Prophetic Centre (RPC) in September 2018. She was appointed Director of Finance of RPC in June 2019. Part of her job description is to prepare the budgets, salaries, contracts and manage the finances of the group. Currently she oversees finance reporting and run the investment portfolio of CLC groups (RPC, IPDYI, THC &amp; BLI). She doubles as committee member of the BLI where she helps to organize Business Seminars and partnership director of RPC.
                  Claire holds an Honors in Business Studies Degree plus 10-year experience in investments (Stockbroking and Asset Management) and sales &amp; marketing. 
                  In her words, “ever since I joined RPC, through Dr Goodhead Uchendu's leadership, I have significantly grown in both my spiritual and personal life including my career. I believe this is as a result of Power filled services and trainings that I have enjoyed under the man of God. I have recorded numerous testimonies in all life fronts. I have also learnt a lot about leadership and how to deal with different personalities through the different Leadership, Human Resources and Financial seminars held in RPC”
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
  <!-- End Team Area -->
  <Footer />
    </div>
</template>

<script>
import Navigation from "./navBar/Navigation";
import Footer from "./Footer";
export default {
  name: "Team",
  components: { Footer, Navigation}
};
</script>

<style scoped>
.team-image {
  height: 300px;
}
</style>
